import { Box } from "@mui/material";
import React from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import MastersContent from "../../components/Masters/MastersContent";
const Masters = () => {
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <MastersContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default Masters;
